module.exports = __webpack_public_path__ + "static/media/furia-intro.ecf08a3d.svg";